<script>
	import Grid from './Grid.svelte';
	import Icon from './General/Icon.svelte';
  	import { translate } from '../lib/translate';
	import { imgFormatter } from '../lib/imgFormatter.js';

	export let media     = [];
	export let columns   = 3;
	export let maxThumbs = images.length;
	export let height    = '500px';

	let activeIndex  = 0;
	let thumbs       = media.slice(0, maxThumbs);
	let showLightbox = false;

	const video = media.findIndex(i => i.type === 'video');
	const photo360 = media.findIndex(i => i.type === '360');

	photo360 > -1 && thumbs.splice(1, 0, { ...media[photo360], index: photo360 });
	video > -1 && thumbs.splice(1, 0, { ...media[video], index: video });

	thumbs = thumbs.slice(0, maxThumbs);

	// Get the yt placeholder from a url
	function getYTPlaceholder(url) {
		return 'https://img.youtube.com/vi/' + url.replace('https://www.youtube.com/embed/', '') + '/1.jpg';
	}

	// Get the yt embed from a url
	function getYTEmbed(url) {
		return 'https://www.youtube.com/embed/' + url.replace('https://www.youtube.com/embed/', '');
	}

	function prev() {
		if (activeIndex === 0) {
			activeIndex = media.length - 1;
		} else {
			activeIndex--;
		}
	}

	function next() {
		if (activeIndex === media.length -1) {
			activeIndex = 0;
		} else {
			activeIndex++;
		}
	}
</script>

<div class="gallery">
	<!-- Please don't touch this mess. It works. -->
	{#if media[activeIndex] && media[activeIndex].type === 'image'}
		<figure class="image" style="--height: {height};" on:click={() => showLightbox = true}>
			<img src={imgFormatter(media[activeIndex].src)} alt="" />
		</figure>
	{/if}
	{#if media[activeIndex] && media[activeIndex].type === 'video'}
		<div class="image">
			<iframe src={getYTEmbed(media[activeIndex].src)} title="video" />
		</div>
	{/if}
	{#if media[activeIndex] && media[activeIndex].type === '360'}
		<div class="image">
			<iframe src={media[activeIndex].src} height="500" frameborder="0" scrolling="no" allowfullscreen title="360"></iframe>
			<div class="view-in-full" on:click={() => showLightbox = true}>
				View in full-screen
			</div>
		</div>
	{/if}
	{#if thumbs.length > 1}
		<Grid {columns}>
			{#each thumbs as thumb, i}
				<div
					class="thumb gallery-thumb-{thumb.type}-type {(activeIndex === thumb.index || activeIndex === i) ? 'active' : ''}"
					on:click={() => activeIndex = thumb.index || i}
				>
					{#if maxThumbs < media.length && i === maxThumbs-1}
						<div
							class="thumb-overlay"
							style="background-image: url({imgFormatter(media[i].src)})"
							on:click={() => {
							activeIndex = i;
							showLightbox = true;
							}}
						>
							<div class="icon">
								<Icon name="IMAGE" color="white" size={43} />
								+ {media.length - maxThumbs}
							</div>
						</div>
					{:else if thumb.type === 'image'}
						<img src={imgFormatter(thumb.src)} alt="" />
					{:else if thumb.type === 'video'}
						<img src={getYTPlaceholder(thumb.src)} alt="" />
						<div class="icon">
							<Icon name="YOUTUBE" color="white" size={50} />
						</div>
					{:else if thumb.type === '360'}
						<div class="photo3d">
							<img src={window.wordpress_object.plugins_url + 'assets/360.png'} alt="" />
						</div>
					{/if}
				</div>
			{/each}
		</Grid>
	{/if}
</div>
{#if showLightbox}
	<div class="lightbox">
		{#if media[activeIndex].type === 'image'}
			<img src={imgFormatter(media[activeIndex].src)} alt="" />
		{/if}
		{#if media[activeIndex] && media[activeIndex].type === 'video'}
			<div class="image">
				<iframe src={getYTEmbed(media[activeIndex].src)} title="video" />
			</div>
		{/if}
		{#if media[activeIndex] && media[activeIndex].type === '360'}
			<div class="image">
				<iframe src={media[activeIndex].src} frameborder="0" scrolling="no" allowfullscreen title="360"></iframe>
			</div>
		{/if}
		<div class="next" on:click={next}>
			<div class="arrow">
				<Icon name="ARROW_RIGHT" size={30} color="#FFFFFF" />
			</div>
		</div>
		<div class="prev" on:click={prev}>
			<div class="arrow">
				<Icon name="ARROW_RIGHT" size={30} rotate={180} color="#FFFFFF" />
			</div>
		</div>
		<div class="close" on:click={() => showLightbox = false}>
			{translate('Close')}
		</div>
	</div>
{/if}

<style type="text/scss" lang="scss">
	.lightbox {
		width: 100vw;
		height: 100vh;
		background-color: black;
		position: fixed;
		top: 0;
		left: 0;
		z-index: 1000;
		display: flex;
		overflow: hidden;
		align-items: center;
		justify-content: center;

		img {
			width: 80vw;
			height: 70vh;
			object-fit: contain;
		}

		.image {
			width: 80vw;
			height: 70vh;

		}

		.prev {
			left: 0;
			bottom: 0;
		}

		.next {
			right: 0;
			bottom: 0;
		}

		.prev,
		.next {
			width: 10%;
			height: 100%;
			display: flex;
			align-items: center;
			justify-content: center;
			position: absolute;

			@media (max-width: 1060px) {
				width: 50%;
				height: 15%;
			}
			.arrow {
				position: relative;
				&:hover::after {
					opacity: 1;
					transform: translate(-50%, -50%) scale(1);
				}

				&::after { 
					content: "";
					width: 200%;
					height: 200%;
					position: absolute;
					top: 50%;
					left: 50%;
					transform: translate(-50%, -50%) scale(0.8);
					background-color: #FFFFFF50;
					border-radius: 100%;
					transition: all .2s ease-in-out;
					opacity: 0;
					cursor: pointer;
				}
			}
		}

		.close {
			color: white;
			position: absolute;
			top: 50px;
			right: 50px;
			font-family: sans-serif;
			font-size: 15px;
			cursor: pointer;
		}
	}

	.gallery {
		width: 100%;
		height: 100%;

		@media (max-width: 899px) {
			margin-bottom: 31px;
		}
	}

	img {
		width: 100%;
	}

	.thumb {
		height: 0;
		position: relative;
		padding-bottom: 80%;
		cursor: pointer;
		overflow: hidden;
		select: none;

		&.gallery-thumb-video-type .icon {
			position: absolute;
			top: 50%;
			left: 50%;
			transform: translate(-50%, -50%);
		}

		&:not(:last-child) {
			margin-right: 13px;

			@media (max-width: 840px) {
				margin-right: 5px;
			}
		}

		img {
			width: 100%;
			height: 100%;
			position: absolute;
			top: 0;
			left: 0;
			object-fit: cover;
			select: none;
		}

		.thumb-overlay {
			width: 100%;
			height: 100%;
			display: flex;
			flex-direction: column;
			position: absolute;
			top: 0;
			left: 0;
			select: none;
			color: white;
			font-weight: 700;
			background-size: cover;
			.icon {
				width: 100%;
				height: 100%;
				display: flex;
				justify-content: center;
				align-items: center;
				flex-direction: column;
				position: absolute;
				top: 0;
				left: 0;
				z-index: 100;
			}
			&::after {
				content: "";
				width: 100%;
				height: 100%;
				position: absolute;
				top: 0;
				left: 0;
				background-color: rgba(0, 0, 0, 0.5);
			}
		}

		&.active {
			outline: solid 2px #000;
		}
	}


	.image {
		height: var(--height);
		position: relative;
		margin-bottom: 20px;
		cursor: zoom-in;

		.view-in-full {
			position: absolute;
			bottom: 30px;
			right: 30px;
			background-color: white;
			color: black;
			padding: 10px 20px;
			border-radius: 100px;
			box-shadow: 0px 3px 10px #00000050;
			cursor: pointer;
		}

		img {
			height: 500px;
			object-fit: cover;
		}

		iframe {
			width: 100%;
			height: 500px;
		}

		@media (min-width: 600px) and (max-width: 899px) {
			height: 400px;

			iframe, img {
				height: 400px;
			}
		}

		@media (min-width: 400px) and (max-width: 599px) {
			height: 250px;

			iframe, img {
				height: 250px;
			}
		}

		@media (max-width: 399px) {
			height: 197px;

			iframe, img {
				height: 197px;
			}
		}
	}

	.photo3d {
		width: 100%;
		height: 100%;
		display: flex;
		justify-content: center;
		align-items: center;
		background-color: #00000050;
		position: absolute;
		top: 0;
		left: 0;
		font-size: 30px;
		text-shadow: 0px 2px 5px #00000080;
		font-weight: bold;
		img {
			filter: invert(100);
			width: 70%;
			object-fit: contain;
			margin-left: 15%;
		}
	}
</style>
